import React, { useState, useEffect, createContext } from "react";
import {
  getWorkspace,
  setWorkspace as setWorkspaceStorage,
} from "@/helpers/auth";

interface IAccountContextProps {
  workspace: string | null;
  setWorkspace: (workspace: string | null) => void;
}

export const AuthContext = createContext<IAccountContextProps>({
  workspace: null,
  setWorkspace: () => {},
});

interface IProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<IProps> = ({ children }) => {
  const [workspace, setWorkspaceState] = useState<string | null>(getWorkspace);

  const setWorkspace = (workspace: string | null) => {
    setWorkspaceState(workspace);
    setWorkspaceStorage(workspace);
  };

  useEffect(() => {
    setWorkspaceStorage(workspace);
  }, [workspace]);

  return (
    <AuthContext.Provider value={{ workspace, setWorkspace }}>
      {children}
    </AuthContext.Provider>
  );
};
